export default [
  {
    path: 'about',
    label: 'About',
  },
  {
    path: 'expertise',
    label: 'Expertise',
  },
  {
    path: 'solution-product',
    label: 'Solution & Product',
  },
  {
    path: 'client',
    label: 'Our Clients',
  },
  {
    path: 'news',
    label: 'News & Update',
  },
];
